<template>
  <div class="user-guide-container">
    <div class="guide-header">
      <div class="header-content">
        <h1 class="guide-main-title">
          <span class="guide-icon">🧭</span>
          Тэнгэр карго – ХЭРЭГЛЭГЧИЙН ГАРЫН АВЛАГА
        </h1>
        <div class="guide-intro-box">
          <p class="guide-intro">
            Тэнгэр карго нь БНХАУ-д байрлах онлайн болон онлайн бус дэлгүүр, нийлүүлэгчээс таны захиалсан барааг
            <span class="highlight">👉 Эрээн дэх агуулахдаа хүлээн авч,</span>
            <span class="highlight">👉 Монгол Улс руу тээвэрлэн,</span>
            <span class="highlight">👉 хэрэглэгчид найдвартай хүргэх</span>
            ачаа тээврийн үйлчилгээ юм.
          </p>
        </div>
      </div>
    </div>

    <div class="guide-content-wrapper">
      <el-collapse v-model="activeNames" accordion class="guide-collapse">
          <el-collapse-item name="1" class="guide-step-item">
            <template slot="title">
              <span class="step-number">1</span>
              <span class="step-title">ҮНЭГҮЙ СУРГАЛТ</span>
            </template>
            <div class="step-content">
              <p class="step-description">Хятадын аппликэйшнүүдээс бараа захиалж сурах үнэгүй видео хичээлүүдийг эндээс үзнэ үү 👇</p>
              <a href="https://www.facebook.com/share/p/1ASUfRLLmg/?mibextid=wwXIfr" target="_blank" class="guide-link-button">
                <i class="el-icon-link"></i> Facebook видео хичээлүүд
              </a>
            </div>
          </el-collapse-item>

          <el-collapse-item name="2" class="guide-step-item">
            <template slot="title">
              <span class="step-number">2</span>
              <span class="step-title">ТЭНГЭР КАРГОНЫ ХАЯГ ХОЛБОХ</span>
            </template>
            <div class="step-content">
              <p class="step-description">Хятадын бараа захиалгын аппликэйшн дээр захиалга хийхийн тулд Тэнгэр каргоны Эрээн агуулахын хаягийг заавал холбоно.</p>
              <p class="step-note">👉 Энгийн тээвэр / Экспресс тээвэр-ийн хаягийг хялбархан хуулж, холбох бол дараах холбоосоор орно уу.</p>
              <a href="https://www.skycargo.mn/join" target="_blank" class="guide-link-button primary">
                <i class="el-icon-link"></i> Хаяг холбох хуудас
              </a>
              <div class="video-guides">
                <p class="video-title">🎥 Бичлэгээр үзэж дагаж хийх бол:</p>
                <div class="video-list">
                  <a href="https://www.facebook.com/reel/659553569844913" target="_blank" class="video-link">
                    <i class="el-icon-video-camera"></i> Taobao хаяг холбох заавар
                  </a>
                  <a href="https://www.facebook.com/reel/1278607943440550" target="_blank" class="video-link">
                    <i class="el-icon-video-camera"></i> Pinduoduo хаяг холбох заавар
                  </a>
                  <a href="https://www.facebook.com/reel/939397891593586" target="_blank" class="video-link">
                    <i class="el-icon-video-camera"></i> 1688 хаяг холбох заавар
                  </a>
                  <div class="video-link coming-soon">
                    <i class="el-icon-time"></i> Dewu / Poizon хаяг холбох заавар – Тун удахгүй
                  </div>
                </div>
              </div>
            </div>
          </el-collapse-item>

          <el-collapse-item name="3" class="guide-step-item">
            <template slot="title">
              <span class="step-number">3</span>
              <span class="step-title">ХОЛБОСОН ХАЯГАА ШАЛГУУЛАХ</span>
            </template>
            <div class="step-content">
              <p class="step-description">Хаягаа холбож дууссаны дараа зөв холбогдсон эсэхийг заавал шалгуулах хэрэгтэй. Ингэснээр:</p>
              <ul class="guide-list">
                <li>ачаа буруу газар хүргэгдэх</li>
                <li>замдаа алга болох</li>
                <li>хугацаа алдах</li>
              </ul>
              <p class="step-note">зэрэг эрсдэлээс сэргийлнэ.</p>
              <p class="step-note">👉 Тэнгэр карго Facebook Page-ийн чат руу бичиж шалгуулна уу</p>
              <a href="https://www.facebook.com/share/15uFFuPKsx/?mibextid=wwXIfr" target="_blank" class="guide-link-button">
                <i class="el-icon-message"></i> Facebook чат
              </a>
            </div>
          </el-collapse-item>

          <el-collapse-item name="4" class="guide-step-item">
            <template slot="title">
              <span class="step-number">4</span>
              <span class="step-title">ЗАХИАЛГА ХИЙХДЭЭ АНХААРАХ ЗҮЙЛС</span>
            </template>
            <div class="step-content">
              <ul class="guide-list">
                <li>Экспресс / энгийн тээврийн хаягаа зөв сонгосон эсэх</li>
                <li>Дэлгүүрийн үнэлгээ, найдвартай байдлыг нягталж найдвартай нийлүүлэгчээс захиалах</li>
                <li>Барааны бодит зураг, хэрэглэгчийн сэтгэгдлийг харж захиалгаа хийх</li>
                <li>Эмзэг, эвдрэх магадлалтай бараанд сав баглаа боодлыг сайтар хийхийг нийлүүлэгчид сануулах</li>
                <li>Каргоны төлбөрийг урьдчилан тооцоолж үзэх</li>
              </ul>
              <p class="step-note">👉 Урьдчилсан үнэ тооцоолох 👇</p>
              <a href="https://www.skycargo.mn/calculate" target="_blank" class="guide-link-button primary">
                <i class="el-icon-calculator"></i> Үнэ тооцоолох
              </a>
            </div>
          </el-collapse-item>

          <el-collapse-item name="5" class="guide-step-item">
            <template slot="title">
              <span class="step-number">5</span>
              <span class="step-title">SKYCARGO.MN СИСТЕМ АШИГЛАХ</span>
            </template>
            <div class="step-content">
              <p class="step-description">📦 Skycargo.mn систем нь таны ачааг Эрээн дэх агуулахад хүлээн авснаас эхлэн Монголд ирж, таны гар дээр хүрэх хүртэлх бүх явц, төлөвийг нэг дороос бүрэн хянах боломжийг олгодог цогц систем юм.</p>
              <div class="link-group">
                <a href="https://www.facebook.com/share/r/18rjRwFKZu/?mibextid=wwXIfr" target="_blank" class="guide-link-button">
                  <i class="el-icon-user"></i> Бүртгүүлэх заавар
                </a>
                <a href="https://www.facebook.com/share/r/1Gzctfe1SL/?mibextid=wwXIfr" target="_blank" class="guide-link-button">
                  <i class="el-icon-document"></i> Трак код бүртгэх заавар
                </a>
              </div>
              <div class="warning-box">
                <p class="warning-title">⚠️ Анхааруулга</p>
                <p>Зарим тохиолдолд таны ачаа утасны дугаараар бус, зөвхөн трак кодоор системд бүртгэгдэх боломжтой. Ийм үед та ачаагаа трак кодоор хайж, шалгана.</p>
                <div class="link-group">
                  <a href="https://www.facebook.com/share/r/19w5FXVkNY/?mibextid=wwXIfr" target="_blank" class="guide-link-button small">
                    <i class="el-icon-view"></i> Трак код харах
                  </a>
                  <a href="https://www.facebook.com/share/r/1EU5KKMhqr/?mibextid=wwXIfr" target="_blank" class="guide-link-button small">
                    <i class="el-icon-search"></i> Дугааргүй ачаа хайх
                  </a>
                </div>
              </div>
            </div>
          </el-collapse-item>

          <el-collapse-item name="6" class="guide-step-item">
            <template slot="title">
              <span class="step-number">6</span>
              <span class="step-title">МОНГОЛД ИРСЭН АЧААГАА АВАХ</span>
            </template>
            <div class="step-content">
              <p class="step-description">Монгол дахь салбарт хүлээн авсан төлөвт орсон ачаагаа:</p>
              <ul class="guide-list">
                <li>Захиалсан салбараасаа очиж авах</li>
                <li>Эсвэл хүргэлтээр авах боломжтой</li>
              </ul>
              <div class="link-group">
                <a href="https://www.skycargo.mn/branches" target="_blank" class="guide-link-button">
                  <i class="el-icon-location"></i> Салбаруудын мэдээлэл
                </a>
                <a href="https://www.facebook.com/share/r/159Y2cQgUq/?mibextid=wwXIfr" target="_blank" class="guide-link-button">
                  <i class="el-icon-truck"></i> Хүргэлт захиалах
                </a>
                <a href="https://www.skycargo.mn/termsOfService" target="_blank" class="guide-link-button">
                  <i class="el-icon-document"></i> Хүргэлтийн журам
                </a>
              </div>
            </div>
          </el-collapse-item>

          <el-collapse-item name="7" class="guide-step-item">
            <template slot="title">
              <span class="step-number">7</span>
              <span class="step-title">АЧАА ИРСЭН МЭДЭГДЭЛ</span>
            </template>
            <div class="step-content">
              <p class="step-description">Таны ачаа Монгол дахь салбарт ирэхэд болон хадгалалтын хугацаа дуусах үед таны утасны дугаарт мессежээр мэдэгдэл илгээнэ.</p>
            </div>
          </el-collapse-item>

          <el-collapse-item name="8" class="guide-step-item">
            <template slot="title">
              <span class="step-number">8</span>
              <span class="step-title">ИРЭЭГҮЙ АЧАА ШАЛГУУЛАХ</span>
            </template>
            <div class="step-content">
              <p class="step-description">Дараах тохиолдолд ачаа шалгуулах шаардлагатай:</p>
              <ul class="guide-list">
                <li>Захиалгын апп дээр Эрээнд очсон боловч 3 хоногийн дотор Skycargo.mn системд "Эрээн агуулах хүлээн авсан" төлөвт ороогүй</li>
                <li>Эрээн агуулахад хүлээн авснаас хойш
                  <ul>
                    <li>Экспресс тээвэр: 5 хоног</li>
                    <li>Энгийн тээвэр: 14 хоног</li>
                  </ul>
                  дотор Монгол дахь салбарт бүртгэгдээгүй
                </li>
              </ul>
              <p class="step-note">👉 www.skycargo.mn → Өөрийн бүртгэл → Захиалга → Трак код шалгуулах</p>
            </div>
          </el-collapse-item>

          <el-collapse-item name="9" class="guide-step-item">
            <template slot="title">
              <span class="step-number">9</span>
              <span class="step-title">АЧАА ХАДГАЛАЛТ</span>
            </template>
            <div class="step-content">
              <ul class="guide-list">
                <li>Монгол дахь салбарт ирснээс хойш 10 хоног үнэгүй</li>
                <li>10 хоногоос хэтэрвэл хадгалалтын төлбөр тооцно</li>
              </ul>
              <div class="info-box">
                <p class="info-title">📌 Хадгалалтын төлбөр</p>
                <ul class="guide-list">
                  <li>Утасны дугаараар бүртгэлтэй ачаа → хоногт тээврийн үнийн 10%</li>
                  <li>Трак кодоор бүртгэгдсэн ачаа → хоногт тээврийн үнийн 1%</li>
                </ul>
              </div>
            </div>
          </el-collapse-item>

          <el-collapse-item name="10" class="guide-step-item">
            <template slot="title">
              <span class="step-number">10</span>
              <span class="step-title">ҮЙЛЧИЛГЭЭНИЙ НӨХЦӨЛ</span>
            </template>
            <div class="step-content">
              <p class="step-description">Хэрэглэгчтэй холбоотой бүх харилцаа Үйлчилгээний нөхцөлийн дагуу явагддаг тул заавал уншина уу 👇</p>
              <a href="https://www.skycargo.mn/termsOfService" target="_blank" class="guide-link-button primary">
                <i class="el-icon-document"></i> Үйлчилгээний нөхцөл
              </a>
            </div>
          </el-collapse-item>

          <el-collapse-item name="11" class="guide-step-item">
            <template slot="title">
              <span class="step-number">11</span>
              <span class="step-title">ХОЛБОО БАРИХ</span>
            </template>
            <div class="step-content">
              <div class="contact-info">
                <p class="contact-item">
                  <i class="el-icon-phone"></i>
                  <strong>Лавлах утас:</strong> 7272-1280 (Ажлын цагаар)
                </p>
                <p class="contact-item">
                  <i class="el-icon-message"></i>
                  <strong>Facebook Messenger:</strong>
                </p>
                <a href="https://www.facebook.com/profile.php?id=100071635914582" target="_blank" class="guide-link-button">
                  <i class="el-icon-chat-line-round"></i> Messenger-ээр холбогдох
                </a>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
  </div>
</template>

<script>
export default {
  name: 'UserGuide',
  data () {
    return {
      activeNames: []
    }
  }
}
</script>

<style scoped>
.user-guide-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
  min-height: 500px;
  font-family: 'Geologica', sans-serif;
}

/* Header Styles */
.guide-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 16px;
  padding: 40px;
  margin-bottom: 40px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

.header-content {
  text-align: center;
}

.guide-main-title {
  font-size: 32px;
  font-weight: bold;
  color: #fff;
  margin: 0 0 20px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
}

.guide-icon {
  font-size: 40px;
}

.guide-intro-box {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 12px;
  padding: 25px;
  margin-top: 20px;
}

.guide-intro {
  font-size: 16px;
  line-height: 1.8;
  color: #333;
  text-align: justify;
  margin: 0;
}

.highlight {
  color: #667eea;
  font-weight: 600;
}

/* Content Wrapper */
.guide-content-wrapper {
  max-width: 900px;
  margin: 0 auto;
}

/* Collapse Styles */
.guide-collapse {
  border: none;
}

.guide-step-item {
  margin-bottom: 16px;
  border: 1px solid #e4e7ed;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.guide-step-item:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  border-color: #667eea;
}

.guide-step-item >>> .el-collapse-item__header {
  padding: 20px 24px;
  font-size: 16px;
  font-weight: 600;
  background: #f8f9fa;
  border-bottom: none;
  display: flex;
  align-items: center;
  gap: 15px;
}

.guide-step-item >>> .el-collapse-item__header.is-active {
  background: #667eea;
  color: #fff;
}

.guide-step-item >>> .el-collapse-item__wrap {
  border-bottom: none;
}

.guide-step-item >>> .el-collapse-item__content {
  padding: 0;
}

.step-number {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background: #667eea;
  color: #fff;
  border-radius: 50%;
  font-weight: bold;
  font-size: 16px;
  flex-shrink: 0;
}

.guide-step-item >>> .el-collapse-item__header.is-active .step-number {
  background: #fff;
  color: #667eea;
}

.step-title {
  flex: 1;
}

.step-content {
  padding: 24px;
  background: #fff;
}

.step-description {
  font-size: 15px;
  line-height: 1.8;
  color: #333;
  margin: 0 0 16px 0;
}

.step-note {
  font-size: 14px;
  line-height: 1.7;
  color: #666;
  margin: 12px 0;
}

/* Link Buttons */
.guide-link-button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  background: #f0f2f5;
  color: #333;
  text-decoration: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  margin: 8px 8px 8px 0;
  transition: all 0.3s ease;
  border: 1px solid #e4e7ed;
}

.guide-link-button:hover {
  background: #667eea;
  color: #fff;
  border-color: #667eea;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.guide-link-button.primary {
  background: #667eea;
  color: #fff;
  border-color: #667eea;
}

.guide-link-button.primary:hover {
  background: #5568d3;
  border-color: #5568d3;
}

.guide-link-button.small {
  padding: 8px 16px;
  font-size: 13px;
}

.guide-link-button i {
  font-size: 16px;
}

/* Link Groups */
.link-group {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin: 16px 0;
}

/* Video Guides */
.video-guides {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #e4e7ed;
}

.video-title {
  font-size: 15px;
  font-weight: 600;
  color: #333;
  margin-bottom: 12px;
}

.video-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.video-link {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  background: #f8f9fa;
  border-radius: 8px;
  color: #333;
  text-decoration: none;
  transition: all 0.3s ease;
  border: 1px solid #e4e7ed;
}

.video-link:hover {
  background: #667eea;
  color: #fff;
  border-color: #667eea;
}

.video-link.coming-soon {
  opacity: 0.6;
  cursor: not-allowed;
}

.video-link i {
  font-size: 18px;
}

/* Warning Box */
.warning-box {
  margin-top: 20px;
  padding: 16px;
  background: #fff3cd;
  border-left: 4px solid #ffc107;
  border-radius: 8px;
}

.warning-title {
  font-size: 15px;
  font-weight: 600;
  color: #856404;
  margin: 0 0 10px 0;
}

.warning-box p {
  font-size: 14px;
  color: #856404;
  line-height: 1.6;
  margin: 0 0 12px 0;
}

/* Info Box */
.info-box {
  margin-top: 16px;
  padding: 16px;
  background: #e7f3ff;
  border-left: 4px solid #007AFF;
  border-radius: 8px;
}

.info-title {
  font-size: 15px;
  font-weight: 600;
  color: #004085;
  margin: 0 0 10px 0;
}

/* Contact Info */
.contact-info {
  margin-top: 10px;
}

.contact-item {
  font-size: 15px;
  line-height: 1.8;
  color: #333;
  margin: 12px 0;
  display: flex;
  align-items: center;
  gap: 10px;
}

.contact-item i {
  font-size: 20px;
  color: #667eea;
}

.contact-item strong {
  color: #333;
  margin-left: 5px;
}

/* Lists */
.guide-list {
  margin: 12px 0;
  padding-right: 20px;
  list-style-type: disc;
}

.guide-list li {
  margin: 10px 0;
  font-size: 14px;
  color: #555;
  line-height: 1.7;
}

.guide-list ul {
  margin-top: 8px;
  padding-right: 20px;
}

/* Responsive */
@media all and (max-width: 991px) {
  .user-guide-container {
    padding: 20px 15px;
  }

  .guide-header {
    padding: 25px 20px;
  }

  .guide-main-title {
    font-size: 24px;
    flex-direction: column;
    gap: 10px;
  }

  .guide-icon {
    font-size: 32px;
  }

  .guide-intro {
    font-size: 14px;
  }

  .guide-step-item >>> .el-collapse-item__header {
    padding: 16px;
    font-size: 14px;
  }

  .step-number {
    width: 30px;
    height: 30px;
    font-size: 14px;
  }

  .step-content {
    padding: 16px;
  }

  .step-description {
    font-size: 14px;
  }

  .guide-link-button {
    padding: 10px 16px;
    font-size: 13px;
  }

  .link-group {
    flex-direction: column;
  }
}
</style>
